import React from 'react';
import { Facebook, Instagram, Twitter, Youtube, Linkedin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-b from-gray-900 to-black text-white relative overflow-hidden">
      {/* Background Decoration */}
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-amber-500/5 rounded-full blur-3xl"></div>

      {/* Main Footer Content */}
      <div className="relative z-10 container mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <h2 className="text-4xl font-bold mb-4">
              <span className="bg-gradient-to-r from-amber-400 to-amber-600 bg-clip-text text-transparent">
                GOS MÉDIA
              </span>
            </h2>
            <p className="text-gray-400 mb-6 text-lg leading-relaxed">
              Votre partenaire de confiance pour immortaliser vos moments les plus précieux avec professionnalisme et créativité.
            </p>
            <div className="flex gap-4">
              <a href="#" className="w-12 h-12 bg-white/10 hover:bg-amber-500 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110">
                <Facebook className="h-5 w-5" />
              </a>
              <a href="#" className="w-12 h-12 bg-white/10 hover:bg-amber-500 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110">
                <Instagram className="h-5 w-5" />
              </a>
              <a href="#" className="w-12 h-12 bg-white/10 hover:bg-amber-500 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110">
                <Twitter className="h-5 w-5" />
              </a>
              <a href="#" className="w-12 h-12 bg-white/10 hover:bg-amber-500 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110">
                <Youtube className="h-5 w-5" />
              </a>
              <a href="#" className="w-12 h-12 bg-white/10 hover:bg-amber-500 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110">
                <Linkedin className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Services Column */}
          <div>
            <h3 className="text-xl font-bold mb-6">Nos Services</h3>
            <ul className="space-y-3">
              <li><a href="#" className="text-gray-400 hover:text-amber-400 transition-colors">Mariages</a></li>
              <li><a href="#" className="text-gray-400 hover:text-amber-400 transition-colors">Cérémonies Traditionnelles</a></li>
              <li><a href="#" className="text-gray-400 hover:text-amber-400 transition-colors">Conférences</a></li>
              <li><a href="#" className="text-gray-400 hover:text-amber-400 transition-colors">Événements Gouvernementaux</a></li>
              <li><a href="#" className="text-gray-400 hover:text-amber-400 transition-colors">Corporate</a></li>
            </ul>
          </div>

          {/* Quick Links Column */}
          <div>
            <h3 className="text-xl font-bold mb-6">Liens Rapides</h3>
            <ul className="space-y-3">
              <li><a href="#" className="text-gray-400 hover:text-amber-400 transition-colors">À Propos</a></li>
              <li><a href="#portfolio" className="text-gray-400 hover:text-amber-400 transition-colors">Portfolio</a></li>
              <li><a href="#pricing" className="text-gray-400 hover:text-amber-400 transition-colors">Tarifs</a></li>
              <li><a href="#" className="text-gray-400 hover:text-amber-400 transition-colors">Blog</a></li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm">
            © 2025 GOS MÉDIA. Tous droits réservés.
          </p>
          <div className="flex gap-6 text-sm">
            <a href="#" className="text-gray-400 hover:text-amber-400 transition-colors">Politique de Confidentialité</a>
            <a href="#" className="text-gray-400 hover:text-amber-400 transition-colors">Conditions d'Utilisation</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
